import React from 'react';
import './separator.scss';

const Separator = () => <div styleName="separator" />;

export default Separator;
